import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Button, LinkTo, renderField } from '../../../helpers';

function ResetPasswordForm({ isLoading, successMessage, errorMessage, handleSubmit, onSubmit }) {
  return (
    <form className="floating-labels m-t-40" onSubmit={handleSubmit(user => onSubmit(user))}>
      {successMessage ? (
        <div className="alert alert-success">
          {successMessage}
        </div>
      ) : null}

      <Field
        material
        required
        className="form-control"
        name="username"
        label="Email"
        component={renderField}
      />

      {errorMessage ? (
        <div className="alert alert-danger">
          {errorMessage}
        </div>
      ) : null}

      <div className="form-group m-b-40">
        <div className="col-md-12">
          <LinkTo href="auth" className="text-dark pull-right">
            Already have an account?
          </LinkTo>
        </div>
      </div>

      <div className="form-group text-center m-t-20">
        <div className="col-xs-12">
          <Button
            submit
            disabled={isLoading}
            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
          >
            {isLoading ? 'Processing...' : 'Reset Password'}
          </Button>
        </div>
      </div>
    </form>
  );
}

ResetPasswordForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

ResetPasswordForm.defaultProps = {
  successMessage: null,
  errorMessage: null
};

function validate({ username }) {
  const errors = {};

  if (!username) {
    errors.username = 'Please enter a username';
  }

  return errors;
}

export default reduxForm({ form: 'reset-password', validate })(ResetPasswordForm);
